var map = {
	"./bookshelves/bookshelf-basic-1.png": 957,
	"./bookshelves/bookshelf-basic-2.png": 958,
	"./bookshelves/bookshelf-basic-3.png": 959,
	"./bookshelves/bookshelf-basic-4.png": 960,
	"./bookshelves/bookshelf-beach.png": 961,
	"./bookshelves/bookshelf-chef.png": 962,
	"./bookshelves/bookshelf-circus.png": 963,
	"./bookshelves/bookshelf-gamer.png": 964,
	"./bookshelves/bookshelf-jam.png": 965,
	"./bookshelves/bookshelf-pirate.png": 966,
	"./bookshelves/bookshelf-skate.png": 967,
	"./bookshelves/bookshelf-sports.png": 968,
	"./bookshelves/bookshelf-winter.png": 969,
	"./bookshelves/bookshelf-wizard.png": 970,
	"./floor_items/basketball.png": 971,
	"./floor_items/chest.png": 972,
	"./floor_items/coffee-table.png": 973,
	"./floor_items/electric-guitar.png": 974,
	"./floor_items/fireplace.png": 975,
	"./floor_items/football.png": 976,
	"./floor_items/game-controller.png": 977,
	"./floor_items/green-skateboard.png": 978,
	"./floor_items/magic-book.png": 979,
	"./floor_items/magic-staff.png": 980,
	"./floor_items/mask.png": 981,
	"./floor_items/palm-tree.png": 982,
	"./floor_items/popcorn.png": 983,
	"./floor_items/red-skateboard.png": 984,
	"./floor_items/sandcastle.png": 985,
	"./floor_items/side-table.png": 986,
	"./floor_items/violin.png": 987,
	"./floor_items/wand.png": 988,
	"./sofas/sofa-beach.png": 989,
	"./sofas/sofa-chef.png": 990,
	"./sofas/sofa-circus.png": 991,
	"./sofas/sofa-gamer.png": 992,
	"./sofas/sofa-jam.png": 993,
	"./sofas/sofa-pirate.png": 994,
	"./sofas/sofa-skate.png": 995,
	"./sofas/sofa-sports.png": 996,
	"./sofas/sofa-winter.png": 997,
	"./sofas/sofa-wizard.png": 998,
	"./wall_items/double-note-poster.png": 999,
	"./wall_items/dragon-poster.png": 1000,
	"./wall_items/elephant-poster.png": 1001,
	"./wall_items/helm.png": 1002,
	"./wall_items/pirate-flag.png": 1003,
	"./wall_items/rocket-poster.png": 1004,
	"./wall_items/single-note-poster.png": 1005,
	"./wall_items/surfboard.png": 1006,
	"./wall_items/television.png": 1007,
	"./wall_items/window-night-beach.png": 1008,
	"./wall_items/window-night-lake.png": 1009,
	"./wall_items/window-night-mountains.png": 1010,
	"./wall_items/window-snowy-mountains.png": 1011,
	"./wall_items/window-sunny-beach.png": 1012,
	"./wall_items/window-sunny-lake.png": 1013,
	"./wall_items/window-sunny-mountains.png": 1014,
	"./wall_items/window-sunset-beach.png": 1015,
	"./wall_items/window-sunset-lake.png": 1016
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 365;



//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures .*\.png
// module id = 365
// module chunks = 0